import React, { useState, useEffect, useContext, useRef } from 'react';

import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
import AgreementService from "../../Controller/AgreementController";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import QuotationService from "../../../Quotation/Controller/QuotationController";
import CustomerService from "../../../Customer/Controller/CustomerController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
import { handleChange as handleSaleChange, handleSubmit as handleSaleSubmit } from "../../../SaleOrder/Controller/CreateSaleOrderController";
import SaleOrderService from '../../../SaleOrder/Controller/SaleOrderController';

const useSaleOrder = (setLoading, setSelectedParts, tableRef, fetchQuotation) => {

    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const getCurrentDateTime = () => {
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        const time = now.toTimeString().split(' ')[0]; // Format: HH:MM:SS
        return { date, time };
    };
    const { date, time } = getCurrentDateTime();
    const [errors, setErrors] = useState({});
    const [selectedPartsForSale, setSelectedPartForSale] = useState([]);
    const fetchAgreementDetail = async (AgreementID) => {
        try {
            const redirectCallback = () => navigate('/');
            const agreementDetail = await AgreementService.GetAgreementByID(redirectCallback, AgreementID);
            return agreementDetail;
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const fetchAgreementItems = async (AgreementID, currencySymbol, ConversionRate) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const agreementDetail = await AgreementService.GetAgreementDescriptionByID(redirectCallback, AgreementID);

            const selectedPartsData = await Promise.all(agreementDetail.map(async (detail) => {
                const convertedStockPrice = parseFloat(detail.mon_StockPrice * ConversionRate).toFixed(2);
                const convertedmon_SalesPrice = parseFloat(detail.mon_SalesPrice * ConversionRate).toFixed(2);
                const converteddec_VAT = parseFloat(detail.dec_VAT * ConversionRate).toFixed(2);
                const converteddec_Quantity = parseFloat(detail.dec_Quantity * ConversionRate).toFixed(2);
                const convertednet_SalesPrice = parseFloat(detail.net_SalesPrice * ConversionRate).toFixed(2);
                const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                const convertedmon_SellingPrice = parseFloat(detail.mon_SellingPrice * ConversionRate).toFixed(2);
                const convertedmon_dec_Allocated = parseFloat(detail.dec_Allocated * ConversionRate).toFixed(2);
                const convertedmon_dec_FreeStock = parseFloat(detail.dec_FreeStock * ConversionRate).toFixed(2);
                const convertedmon_mon_AverageCostPrice = parseFloat(detail.mon_AverageCostPrice * ConversionRate).toFixed(2);

                return {
                    vc_StockCode: detail.vc_StockCode,
                    vc_Description: detail.vc_Description,
                    mon_StockPrice: convertedStockPrice, // Use the converted price
                    mon_SalesPrice: convertedmon_SalesPrice,
                    dec_Quantity: detail.dec_Quantity,
                    vc_UnitOfSale: detail.vc_UnitOfSale,
                    net_SalesPrice: parseFloat(convertednet_SalesPrice).toFixed(2),
                    net_VATPrice: parseFloat(converteddec_VAT).toFixed(2),
                    vc_StockName: detail.vc_Description,
                    PK_Stock_ID: detail.FK_Stock_ID,
                    dec_Discount: detail.dec_Discount,
                    mon_SellingPrice: convertedmon_SalesPrice,
                    dec_Allocated: convertedmon_dec_Allocated,
                    dec_FreeStock: convertedmon_dec_FreeStock,
                    mon_AverageCostPrice: convertedmon_mon_AverageCostPrice,

                    mon_NetPrice: parseFloat(detail.net_SalesPrice * ConversionRate).toFixed(2),
                    mon_VATPrice: parseFloat(detail.net_VATPrice * ConversionRate).toFixed(2),
                    mon_DiscountNetPrice: parseFloat(detail.dec_Discount * ConversionRate).toFixed(2),
                    // Map other fields as needed
                };
            }));
            debugger;
            return selectedPartsData;

        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };


    const handleSaleOrder = async (event, selectedId) => {
        setLoading(true);
        try {
            const ID = selectedId;
            const redirectCallback = () => navigate('/');
            if (ID > 0) {
                const quotationDetail = await fetchAgreementDetail(ID);
                const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
                debugger;

                const selectedCustomer = listOfCustomers.find(customer => customer.ClientCompanyID === parseInt(quotationDetail[0].ClientCompanyID));
                const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
                const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
                let ConversionRate = await convertCurrency(listOfCurreny[0].Symbol, selectedCustomer.vc_CurrencySymbol, currencyData, "0");
                ConversionRate="1";
                const QuotationItemsList = await fetchAgreementItems(ID, selectedCustomer.vc_CurrencySymbol, ConversionRate);
                const formData = {
                    ClientType:"0",
                    CustomerID: quotationDetail[0].ClientCompanyID,
                    FK_ClientBranch_ID: quotationDetail[0].FK_ClientBranch_ID,
                    FK_ClientContact_ID: quotationDetail[0].FK_ClientContact_ID,
                    vc_CustomerOrderNumber: quotationDetail[0].vc_CustomerOrderNumber,
                    vc_User5: quotationDetail[0].contractNumber,
                    BaseCurrency: listOfCurreny[0].Symbol,
                    int_DiscountType: quotationDetail[0].int_DiscountType,
                    dec_DiscountAmount: quotationDetail[0].dec_DiscountAmount,
                    dec_DiscountNETTotal: parseFloat(quotationDetail[0].dec_DiscountNETTotal * ConversionRate).toFixed(2),
                    mon_TotalPrice: parseFloat(quotationDetail[0].mon_TotalPrice * ConversionRate).toFixed(2),
                    mon_TotalPriceO: parseFloat(quotationDetail[0].mon_TotalPriceO * ConversionRate).toFixed(2),
                    mon_TotalPriceG: parseFloat(quotationDetail[0].mon_TotalPriceG * ConversionRate).toFixed(2),
                    mon_DeliveryNetTotal: quotationDetail[0].mon_DeliveryNetTotal != null
                        ? parseFloat(quotationDetail[0].mon_DeliveryNetTotal * ConversionRate).toFixed(2)
                        : "0.00",

                    mon_DeliveryVATTotal: quotationDetail[0].mon_DeliveryVATTotal != null
                        ? parseFloat(quotationDetail[0].mon_DeliveryVATTotal * ConversionRate).toFixed(2)
                        : "0.00",
                    dec_CurrencyToBaseRate: ConversionRate,
                    dt_SalesOrderDate: date,
                    FK_SalesOrderStatus_ID: "1",
                    FK_SalesOrderSource_ID: "2",
                    snt_PaymentMethod: "1",
                    FK_SalesOrderType_ID: "1",
                    bit_DropShipment:"2"
                };

                const newParts = QuotationItemsList.map(item => ({
                    vc_StockCode: item.vc_StockCode,
                    vc_Description: item.vc_Description,
                    mon_SalesPrice: item.mon_SalesPrice,
                    vc_Quantity: item.vc_Quantity,
                    mon_StockPrice: item.mon_StockPrice,
                    mon_AverageCostPrice: "0.00",
                    vc_StockName: item.vc_StockName,
                    mon_LastPurchasePrice: item.mon_LastPurchasePrice,
                    dt_LastSaleDate: item.dt_LastSaleDate,
                    dt_StockTakeDate: item.dt_StockTakeDate,
                    dec_TaxCode: item.dec_TaxCode,
                    vc_UnitOfSale: item.vc_UnitOfSale,
                    snt_PurchaseNominalCode: item.snt_PurchaseNominalCode,
                    snt_SalesNominalCode: item.dec_Quantity,
                    dec_Quantity: item.dec_Quantity,
                    PK_Stock_ID: item.PK_Stock_ID,
                    net_SalesPrice: item.mon_NetPrice,
                    net_VATPrice: item.mon_VATPrice,
                    dec_Discount: item.mon_DiscountNetPrice,
                    dec_TotalDiscount: item.dec_Discount,
                    dec_Allocated: "0.00",
                    dec_FreeStock: "0.00",
                    dec_QtyInStock: "0.00",

                }));

                await setSelectedPartForSale(prevParts => [...prevParts, ...newParts]);
                const formDataWithParts = {
                    formData: formData,
                    selectedParts: newParts
                };
                debugger;
                const message = await handleSaleSubmit(event, formDataWithParts, "", setErrors);
                debugger;
                const SaleOrderID = localStorage.getItem("SaleOrderID");
                 await SaleOrderService.SetSaleOrderNo(ID, SaleOrderID);
                return message;
            }
        } catch (error) {
            console.error('Error fetching jobs:', error);
        } finally {
            setLoading(false);
        }
    };
    return { handleSaleOrder };
};

export default useSaleOrder;